module.exports = __webpack_public_path__ + "static/media/baner3.f14c8619.jpg";